import { createEvent } from "effector";
import {
  AuthenticationContext,
  AuthResult,
  ActiveUser,
} from "@type/core/auth/auth.types";
import { StatusEnum } from "@utils/enums/status.enum";
import { Right } from "@/type/core/offices/offices.types";

export type SelectedOfficesPayload = {
  id: string;
  rights: Right[];
}[];

export const authenticationContextEvent = createEvent<
  AuthenticationContext | undefined
>();

export const login = createEvent<AuthResult>();

export const setUser = createEvent<ActiveUser>("SET_USER");

export const clearUser = createEvent<void>("CLEAR_USER");

export const logout = createEvent<void>();

export const updateSelectedOfficeIds = createEvent<SelectedOfficesPayload>(
  "UPDATE_SELECTED_OFFICE_IDS",
);

export const setOnboardingToFalse = createEvent<void>(
  "SET_ONBOARDING_TO_FALSE",
);

export const setOnboardingError = createEvent<string>("SET_ONBOARDING_ERROR");

export const setCertificateInfosPhone = createEvent<string>(
  "SET_CERTIFICATE_INFOS_PHONE",
);

export const setCertificateStatus = createEvent<StatusEnum>(
  "SET_CERTIFICATE_STATUS",
);

export const setEmailAndLastnameAndFirstname = createEvent<{
  email: string;
  lastname: string;
  firstname: string;
}>("SET_EMAIL_AND_LASTNAME_AND_FIRSTNAME");

export const setOfficeAlias = createEvent<{
  id: string;
  newAlias: string;
}>("SET_OFFICE_ALIAS");

export const deleteUserPicture = createEvent("DELETE_USER_PICTURE");
